// src/components/Hero.jsx

import React from "react";
import "./Hero.css";
import { Fade } from "react-awesome-reveal";

import heroImage from "../assets/hero-deslocado.svg";
// Recomendo substituir esta URL por uma imagem de alta qualidade que represente a DB Vision.
const heroImageUrl = heroImage;

const Hero = () => {
  return (
    <section
      id="about"
      className="hero"
      style={{
        backgroundImage: `url(${heroImageUrl}), linear-gradient(135deg, #1b2a4b 0%, #0f1a33 100%)`,
      }}
    >
      <div className="hero-content">
        <Fade direction="down" cascade damping={0.1} triggerOnce>
          <h1>
            Do banco de dados ao software,{" "}
            <span className="secondary-color">conectamos inovação</span> à
            performance.
          </h1>
        </Fade>
        <Fade direction="up" delay={500} triggerOnce>
          <p>
            Somos parceiros estratégicos, transformando dados em insights
            valiosos e desafios em oportunidades que impulsionam o sucesso das
            empresas.
          </p>
        </Fade>
      </div>
    </section>
  );
};

export default Hero;
